import React from 'react';

const CareerConfusionSection: React.FC = () => {
  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">前途迷茫怎么办？</h2>
          <p className="text-xl text-gray-600">战略咨询+猎头公司+大数据，顶级职业规划帮你搭乘产业革命浪潮</p>
        </div>

        {/* 合作公司 */}
        <div className="mb-16">
          <h3 className="text-2xl font-bold text-center text-gray-900 mb-12">顶级合作伙伴</h3>
          <div className="grid grid-cols-3 md:grid-cols-3 gap-2 md:gap-8">
            <div className="bg-white p-2 md:p-8 rounded-xl shadow-lg text-center">
              <img 
                src="https://static.readdy.ai/image/369c6d7d3639e005f7b761af84a5109d/5b843cb0f20fd51f7bf692abae7c1bb3.jpeg"
                alt="麦肯锡"
                className="w-full h-24 md:h-48 mx-auto mb-2 md:mb-6 object-contain"
              />
              <h4 className="text-xs md:text-xl font-bold text-gray-900 mb-1 md:mb-3">麦肯锡</h4>
              <p className="text-xs md:text-base text-gray-600">全球第一战略咨询公司，为各国政府及500强企业提供战略，针对庞杂的发展问题给予解决方案</p>
            </div>
            
            <div className="bg-white p-2 md:p-8 rounded-xl shadow-lg text-center">
              <img 
                src="https://static.readdy.ai/image/369c6d7d3639e005f7b761af84a5109d/345bc33662cbf69e1a3a653d79695249.webp"
                alt="领英"
                className="w-full h-24 md:h-48 mx-auto mb-2 md:mb-6 object-contain"
              />
              <h4 className="text-xs md:text-xl font-bold text-gray-900 mb-1 md:mb-3">领英</h4>
              <p className="text-xs md:text-base text-gray-600">全球最大的职场社交平台，用户数超过10亿，拥有遍布全球的200多个国家和地区的影响力以及强大的行业洞察力</p>
            </div>
            
            <div className="bg-white p-2 md:p-8 rounded-xl shadow-lg text-center">
              <img 
                src="https://static.readdy.ai/image/369c6d7d3639e005f7b761af84a5109d/9c338f734242fb1c56e10bec8fcf5bd3.jpeg"
                alt="光辉国际"
                className="w-full h-24 md:h-48 mx-auto mb-2 md:mb-6 object-contain"
              />
              <h4 className="text-xs md:text-xl font-bold text-gray-900 mb-1 md:mb-3">光辉国际</h4>
              <p className="text-xs md:text-base text-gray-600">全球最大猎头公司，纽交所上市，为苹果、英伟达、亚马逊、特斯拉、三星等企业输送超40%的CXO级高管</p>
            </div>
          </div>
        </div>

        {/* 职业规划分析 */}
        <div className="space-y-12">
          <div className="bg-white p-8 rounded-xl shadow-lg">
            <div className="flex flex-col lg:flex-row items-center gap-8">
              <div className="lg:w-1/2">
                <img 
                  src="https://static.readdy.ai/image/369c6d7d3639e005f7b761af84a5109d/75ca1f58430944fb5b99a9bd6dd68c01.png"
                  alt="增长产业分析"
                  className="w-full h-32 md:h-64 object-cover rounded-lg"
                />
              </div>
              <div className="lg:w-1/2">
                <h4 className="text-2xl font-bold text-gray-900 mb-4">增长产业分析</h4>
                <p className="text-lg text-blue-600 font-semibold mb-4">200余个国家和地区的政策分析及全球140万亿美金资本流向</p>
                <div className="space-y-3">
                  <div className="flex items-start space-x-3">
                    <div className="w-2 h-2 bg-blue-600 rounded-full mt-2 flex-shrink-0"></div>
                    <p className="text-gray-700">各国支柱产业的革新方向</p>
                  </div>
                  <div className="flex items-start space-x-3">
                    <div className="w-2 h-2 bg-blue-600 rounded-full mt-2 flex-shrink-0"></div>
                    <p className="text-gray-700">全球新兴行业未来风口</p>
                  </div>
                  <div className="flex items-start space-x-3">
                    <div className="w-2 h-2 bg-blue-600 rounded-full mt-2 flex-shrink-0"></div>
                    <p className="text-gray-700">传统行业的转机</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div className="bg-white p-8 rounded-xl shadow-lg">
            <div className="flex flex-col lg:flex-row-reverse items-center gap-8">
              <div className="lg:w-1/2">
                <img 
                  src="https://static.readdy.ai/image/369c6d7d3639e005f7b761af84a5109d/73566b8e1382d2b12703aed97a93eddd.webp"
                  alt="求职最快路径分析"
                  className="w-full h-32 md:h-64 object-cover rounded-lg"
                />
              </div>
              <div className="lg:w-1/2">
                <h4 className="text-2xl font-bold text-gray-900 mb-4">求职最快路径分析</h4>
                <p className="text-lg text-green-600 font-semibold mb-4">全球10亿人才的职业生涯路径及教育背景</p>
                <div className="space-y-3">
                  <div className="flex items-start space-x-3">
                    <div className="w-2 h-2 bg-green-600 rounded-full mt-2 flex-shrink-0"></div>
                    <p className="text-gray-700">各大名企招聘目标校及半目标校</p>
                  </div>
                  <div className="flex items-start space-x-3">
                    <div className="w-2 h-2 bg-green-600 rounded-full mt-2 flex-shrink-0"></div>
                    <p className="text-gray-700">各岗位录取及被拒人才简历库</p>
                  </div>
                  <div className="flex items-start space-x-3">
                    <div className="w-2 h-2 bg-green-600 rounded-full mt-2 flex-shrink-0"></div>
                    <p className="text-gray-700">典型人才求职、跳槽及升职路径</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div className="bg-white p-8 rounded-xl shadow-lg">
            <div className="flex flex-col lg:flex-row items-center gap-8">
              <div className="lg:w-1/2">
                <img 
                  src="https://static.readdy.ai/image/369c6d7d3639e005f7b761af84a5109d/d46a94d0be8a78b9f4e17c6d225532eb.png"
                  alt="职业生涯高度分析"
                  className="w-full h-32 md:h-64 object-cover rounded-lg"
                />
              </div>
              <div className="lg:w-1/2">
                <h4 className="text-2xl font-bold text-gray-900 mb-4">职业生涯高度分析</h4>
                <p className="text-lg text-orange-600 font-semibold mb-4">匹配您的职业生涯目标：海内外上市公司高管、创业领军人、高校科研人员、各领域技术专家、社会活动家以及艺术家等</p>
                <div className="space-y-3">
                  <div className="flex items-start space-x-3">
                    <div className="w-2 h-2 bg-orange-600 rounded-full mt-2 flex-shrink-0"></div>
                    <p className="text-gray-700">学术背景分析</p>
                  </div>
                  <div className="flex items-start space-x-3">
                    <div className="w-2 h-2 bg-orange-600 rounded-full mt-2 flex-shrink-0"></div>
                    <p className="text-gray-700">职业路径分析</p>
                  </div>
                  <div className="flex items-start space-x-3">
                    <div className="w-2 h-2 bg-orange-600 rounded-full mt-2 flex-shrink-0"></div>
                    <p className="text-gray-700">重大成果分析</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CareerConfusionSection;
